var $e27d69832fa0346c$exports = {};
document.addEventListener("DOMContentLoaded", ()=>{
    const floatingRegister = document.getElementById("floatingRegister");
    const openButton = document.getElementById("openRegisterBot");
    const closeButton = document.getElementById("closeRegisterBot");
    const registerBot = document.getElementById("registerBot");
    /* =========================================================
     ELEMENTOS
  ========================================================= */ if (!floatingRegister || !openButton || !closeButton || !registerBot) return;
    /* =========================================================
     ABRIR / FECHAR
  ========================================================= */ function openBot() {
        registerBot.classList.add("show");
    }
    function closeBot() {
        registerBot.classList.remove("show");
    }
    function toggleBot() {
        registerBot.classList.toggle("show");
    }
    /* =========================================================
     EVENTOS
  ========================================================= */ openButton.addEventListener("click", (event)=>{
        event.stopPropagation();
        toggleBot();
    });
    closeButton.addEventListener("click", (event)=>{
        event.stopPropagation();
        closeBot();
    });
    /* =========================================================
     FECHAR AO CLICAR FORA
  ========================================================= */ document.addEventListener("click", (event)=>{
        const clickedInside = floatingRegister.contains(event.target);
        if (!clickedInside) closeBot();
    });
    /* =========================================================
     ESC
  ========================================================= */ document.addEventListener("keydown", (event)=>{
        if (event.key === "Escape") closeBot();
    });
    /* =========================================================
     LINKS
  ========================================================= */ document.querySelectorAll(".register-bot-link").forEach((link)=>{
        link.addEventListener("click", ()=>{
            closeBot();
        });
    });
});


//# sourceMappingURL=hub-resiliencia-em-rede.5e4d7227.js.map
